import { useMemo, useRef, useState } from 'react';
import { CustomerNewsReportQuery } from 'src/types/Reports/customerReport.model';
import { useFetchDataOptions } from '../Commons/useFetchDataOption';
import { TOption, TRequestOption } from 'src/types/Commons/option.model';
import useUserProfile from '../Users/useUserProfile';
import { OptionType } from 'src/utils/enums/option';
import { FUNC_ID_ALL } from 'src/utils/constants/base';

function useCustomerNewReport() {
  const paramsRef = useRef<null | CustomerNewsReportQuery>(null);
  const [isReload, setIsReload] = useState(false);
  const { profile } = useUserProfile();
  const [errorValidation] = useState();
  const defaultParameter: TRequestOption = {
    userId: profile.userId,
    type: OptionType.ProjectManager,
    take: 10
  };
  //#endregion

  //#region Request API

  const { data: listOptionProjectManager } = useFetchDataOptions(defaultParameter);
  const filterProjectManager = useMemo(() => {
    return [{ value: `${FUNC_ID_ALL}`, label: `Toàn công ty` }, ...(listOptionProjectManager?.data || [])] as TOption[];
  }, [listOptionProjectManager?.data]);

  //#region Events
  const handleFindReport = (requests: CustomerNewsReportQuery) => {
    requests.userId = requests.userId == -1 ? undefined : requests.userId;
    requests.requestId = new Date().getTime();
    paramsRef.current = requests;
    setIsReload(!isReload);
  };
  //#endregion

  return {
    errorValidation,
    handleFindReport,
    paramsRef,
    filterProjectManager
  };
}

export default useCustomerNewReport;
